import type {Dispatch, GetState, ThunkAction} from 'src/reducers';

import {thunkify as flow} from 'src/utils/thunks';
import {key, cached, fetching} from 'src/utils/redux';
import * as reduxApi from 'src/utils/redux-api-bff';
import type {DelayNodeState} from 'src/reducers/delay';


export type DelayAction =
  | UpdateDelayNodeSchedulingAction
  | ReceiveDelayNodeSchedulingAction;

/**
 * Action Name constants definition starts here.
 */

export const UPADTE_DELAY_NODE_SCHEDULING =
  'node-scheduling/update-delay-node-scheduling';

export const RECEIVE_DELAY_NODE_SCHEDULING =
  'node-scheduling/receive-delay-node-scheduling';

/**
 * Action type definition starts here.
 */

type UpdateDelayNodeSchedulingAction = {
  type: typeof UPADTE_DELAY_NODE_SCHEDULING;
  payload: Partial<DelayNodeState>;
};

type ReceiveDelayNodeSchedulingAction = {
  type: typeof RECEIVE_DELAY_NODE_SCHEDULING;
  payload: DelayNodeState;
};

export const updateDelayNodeSchedulingAction = (
  payload: Partial<DelayNodeState>,
): UpdateDelayNodeSchedulingAction => ({
  type: UPADTE_DELAY_NODE_SCHEDULING,
  payload,
});

export const receiveDelayNodeScheduling = (
  payload: DelayNodeState,
): ReceiveDelayNodeSchedulingAction => ({
  type: RECEIVE_DELAY_NODE_SCHEDULING,
  payload,
});

export const fetchDelayNodeScheduling: (
  node_id: string,
) => ThunkAction<unknown> = flow(
  key((node_id) => `workflow-automation/scheduling/${node_id}`),
  fetching(),
)((node_id: string) => (dispatch: Dispatch) => {
  return dispatch(reduxApi.get('node/composite', {node_id})).then((payload) => {
    //TODO : make this simple once data starts comming for all the cases
    const {date_offset, time_offset} = payload.body;
    dispatch(
      receiveDelayNodeScheduling({
        days: date_offset?.days,
        hours: time_offset?.hours,
        minutes: time_offset?.minutes,
      }),
    );
  });
});

// export const updateDelayNodeScheduling =
//   (swimlaneId: string, nodeId: string, workflowId: string): ThunkAction<void> =>
//   (dispatch: Dispatch, getState: GetState) => {
//     const {days, hours, minutes, nodeId} = getState().delay;
//     return dispatch(
//       reduxApi.put(`node`, {
//         node_type: 'schedule',
//         swimlane_id: parseInt(swimlaneId, 10),
//         workflow_id: parseInt(workflowId, 10),
//         body: {
//           type: 'schedule',
//           date_type: SCHEDULE_DATE_TYPES.TRIGGER_DATE,
//           date_value: 'today',
//           time_type: SCHEDULE_TIME_TYPES.TRIGGER_TIME,
//           time_value: 'now',
//           date_offset: {
//             days,
//           },
//           time_offset: {
//             hours,
//             minutes,
//           },
//           id: nodeId,
//         },
//       }),
//     ).then((payload) => {
//       //console.log('delay node update success', payload);
//     });
//   };

// export const createDelayNodeScheduling: (
//   previous_node: string,
//   next_node: string,
//   swimlaneId: string,
//   workflowId: string,
// ) => ThunkAction<mixed> =
//   (previous_node, next_node, swimlaneId, workflowId) =>
//   (dispatch: Dispatch, getState: GetState) => {
//     const {days, hours, minutes} = getState().delay;

//     return dispatch(
//       reduxApi.post(
//         `node`,
//         {
//           node_type: 'schedule',
//           swimlane_id: parseInt(swimlaneId, 10),
//           workflow_id: parseInt(workflowId, 10),
//           body: {
//             date_type: SCHEDULE_DATE_TYPES.TRIGGER_DATE,
//             date_value: 'today',
//             time_type: SCHEDULE_TIME_TYPES.TRIGGER_TIME,
//             time_value: 'now',
//             date_offset: {
//               days,
//             },
//             time_offset: {
//               hours,
//               minutes,
//             },
//           },
//         },
//         {previous_node, next_node},
//       ),
//     );
//   };
